import React, { useState } from 'react';
import { useSelector } from 'react-redux';

import { Spin, Modal, Button } from 'antd';

import SearchInsuredNumbers from './search-insured-numbers';
import InsuredNumbersSelector from './insured-numbers-selector';
import MessageTextArea from './message-text-area';
import { RootState } from '../../../../store';
import { AllInsuredNumbersFilter } from '../../models';

import './styles.less';

type MassSMSProps = {
  showModal: boolean;
  onClose: () => void;
};

const MassSMS = ({ showModal, onClose }: MassSMSProps) => {
  const [filter, setFilter] = useState<AllInsuredNumbersFilter>({} as AllInsuredNumbersFilter);

  const [selectedPhoneNumbersAndNames, setSelectedPhoneNumbersAndNames] = useState<
    { phoneNumber: string; name: string; truckingCompanyId?: string }[]
  >([]);

  const { messageControlParameters, messageControlParametersLoading } = useSelector((state: RootState) => state.smses);

  return (
    <Modal
      title="Mass SMS"
      open={showModal}
      onCancel={onClose}
      onClose={onClose}
      onOk={onClose}
      width={1000}
      footer={[
        <Button key="submit" type="primary" onClick={onClose}>
          Close
        </Button>,
      ]}
    >
      <Spin spinning={messageControlParametersLoading}>
        {showModal && messageControlParameters ? (
          <div className="smses-component">
            <SearchInsuredNumbers setFilter={setFilter} />

            <InsuredNumbersSelector
              filter={filter}
              setSelectedPhoneNumbersAndNames={setSelectedPhoneNumbersAndNames}
              selectedPhoneNumbersAndNames={selectedPhoneNumbersAndNames}
            />

            <MessageTextArea selectedPhoneNumbersAndNames={selectedPhoneNumbersAndNames} />
          </div>
        ) : (
          <p>
            Momentum can send Mass SMS Messages! This feature is not available with the included outgoing SMS line. For further SMS options to enable
            this feature, contact Momentum support.
          </p>
        )}
      </Spin>
    </Modal>
  );
};

export default MassSMS;
